var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      class: { "d-flex flex-column": _vm.mobile },
      style: _vm.mobile ? "height: 100vh" : "",
      attrs: {
        width: _vm.mobile ? null : 380,
        "max-width": _vm.mobile ? null : 380,
        flat: "",
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center pa-2" },
        [
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.$t("ticketing.notifications"))),
          ]),
          _c("v-spacer"),
          _vm.unreadCount > 0
            ? _c(
                "v-btn",
                {
                  attrs: { "x-small": "", text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("mark-all-read")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("ticketing.mark-all-read")) + " ")]
              )
            : _vm._e(),
          _vm.notifications.length
            ? _c(
                "v-btn",
                {
                  attrs: { "x-small": "", text: "", color: "red" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("clear-all")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("ticketing.clear-all")) + " ")]
              )
            : _vm._e(),
          _vm.mobile
            ? _c(
                "v-btn",
                {
                  staticClass: "ml-1",
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("v-divider"),
      !_vm.notifications.length
        ? _c(
            "div",
            { staticClass: "pa-4 text-caption grey--text text-center" },
            [_vm._v(" " + _vm._s(_vm.$t("ticketing.no-notifications")) + " ")]
          )
        : _vm._e(),
      _c(
        "v-list",
        {
          staticClass: "overflow-y-auto notif-list",
          style: _vm.mobile ? "flex: 1 1 auto; overflow-y: auto;" : "",
          attrs: { dense: "", "max-height": _vm.mobile ? null : 400 },
        },
        _vm._l(_vm.notifications, function (n) {
          return _c(
            "v-list-item",
            {
              key: n.id,
              staticClass: "notif-item",
              class: { "unread-notif": !n.read },
              on: {
                click: function ($event) {
                  return _vm.$emit("notification-click", n)
                },
              },
            },
            [
              _c(
                "v-list-item-avatar",
                { staticClass: "my-1 mr-2", attrs: { size: "22" } },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        small: "",
                        color: _vm.notificationColor(n.type),
                      },
                    },
                    [_vm._v(_vm._s(_vm.notificationIcon(n.type)))]
                  ),
                ],
                1
              ),
              _c(
                "v-list-item-content",
                { staticClass: "py-1" },
                [
                  n.ticketTitle || n.organizationName
                    ? _c(
                        "v-list-item-subtitle",
                        { staticClass: "notif-context" },
                        [
                          _c("div", { staticClass: "notif-context__row" }, [
                            _c("span", { staticClass: "notif-emoji" }, [
                              _vm._v("🎟️"),
                            ]),
                            n.ticketTitle
                              ? _c(
                                  "span",
                                  { staticClass: "notif-ticket text-truncate" },
                                  [_vm._v(_vm._s(n.ticketTitle))]
                                )
                              : _vm._e(),
                            _c(
                              "span",
                              {
                                staticClass: "notif-time",
                                attrs: {
                                  title: _vm.formatTimeAbsolute(n.createdAt),
                                },
                              },
                              [_vm._v(_vm._s(_vm.formatTime(n.createdAt)))]
                            ),
                          ]),
                          n.organizationName
                            ? _c(
                                "div",
                                { staticClass: "notif-org text-truncate" },
                                [
                                  _c("span", { staticClass: "notif-emoji" }, [
                                    _vm._v("🏢"),
                                  ]),
                                  _c("span", [
                                    _vm._v(_vm._s(n.organizationName)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "v-list-item-title",
                    { staticClass: "notif-title" },
                    [
                      n.type === "ticket_updated" && n.field
                        ? [
                            _c("span", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                _vm._s(
                                  n.actorName || _vm.$t("ticketing.someone")
                                )
                              ),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  " " +
                                    _vm.$t("ticketing.activity-changed", {
                                      field: _vm.$t(
                                        "ticketing.field." + n.field
                                      ),
                                    })
                                ) +
                                " "
                            ),
                            n.fromValue != null && n.fromValue !== ""
                              ? _c(
                                  "span",
                                  { staticClass: "grey--text text--darken-1" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          " " +
                                            _vm.$t("ticketing.activity-from")
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            n.fromValue != null && n.fromValue !== ""
                              ? _c("span", { staticClass: "activity-value" }, [
                                  _vm._v(_vm._s(n.fromValue)),
                                ])
                              : _vm._e(),
                            _c(
                              "span",
                              { staticClass: "grey--text text--darken-1" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      " " + _vm.$t("ticketing.activity-to")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", { staticClass: "activity-value" }, [
                              _vm._v(_vm._s(n.toValue || "—")),
                            ]),
                          ]
                        : n.type === "attachments_added"
                        ? [
                            _c("span", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                _vm._s(
                                  n.actorName || _vm.$t("ticketing.someone")
                                )
                              ),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  " " +
                                    _vm.$t(
                                      "ticketing.activity-attachments-added"
                                    )
                                ) +
                                " "
                            ),
                            _c("span", { staticClass: "activity-value" }, [
                              _vm._v(_vm._s(n.toValue)),
                            ]),
                          ]
                        : n.type === "attachments_removed"
                        ? [
                            _c("span", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                _vm._s(
                                  n.actorName || _vm.$t("ticketing.someone")
                                )
                              ),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  " " +
                                    _vm.$t(
                                      "ticketing.activity-attachments-removed"
                                    )
                                ) +
                                " "
                            ),
                            _c("span", { staticClass: "activity-value" }, [
                              _vm._v(_vm._s(n.toValue)),
                            ]),
                          ]
                        : n.type === "watcher_added"
                        ? [
                            _c("span", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                _vm._s(
                                  n.actorName || _vm.$t("ticketing.someone")
                                )
                              ),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  " " +
                                    _vm.$t("ticketing.activity-watcher-added")
                                ) +
                                " "
                            ),
                            _c("span", { staticClass: "activity-value" }, [
                              _vm._v(_vm._s(n.toValue)),
                            ]),
                          ]
                        : n.type === "watcher_removed"
                        ? [
                            _c("span", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                _vm._s(
                                  n.actorName || _vm.$t("ticketing.someone")
                                )
                              ),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  " " +
                                    _vm.$t("ticketing.activity-watcher-removed")
                                ) +
                                " "
                            ),
                            _c("span", { staticClass: "activity-value" }, [
                              _vm._v(_vm._s(n.toValue)),
                            ]),
                          ]
                        : [_vm._v(" " + _vm._s(n.message) + " ")],
                      !(n.ticketTitle || n.organizationName)
                        ? _c(
                            "span",
                            {
                              staticClass: "notif-time-inline",
                              attrs: {
                                title: _vm.formatTimeAbsolute(n.createdAt),
                              },
                            },
                            [_vm._v(_vm._s(_vm.formatTime(n.createdAt)))]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "v-list-item-action",
                { staticClass: "my-0 ml-1" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", "x-small": "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("remove", n.id)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { "x-small": "" } }, [
                        _vm._v("mdi-close"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }